import * as Dialog from "@radix-ui/react-dialog";
import { useArticleModalState } from "../../hooks/useArticleModalState";
import { ArticlePageResolver } from "../shared/ArticlePageResolver";

export const ArticleModalProvider = () => {
  const { isArticleModalOpen, setIsArticleModalOpen, articleSlug } =
    useArticleModalState();

  return (
    <Dialog.Root
      open={isArticleModalOpen}
      onOpenChange={(isOpen) => {
        // The article has no way of opening from the inside
        if (!isOpen) setIsArticleModalOpen(false);
      }}
    >
      <ArticlePageResolver
        modal={{
          slug: articleSlug ?? "",
          open: isArticleModalOpen,
        }}
      />
    </Dialog.Root>
  );
};
